import MuiDrawer from "@mui/material/Drawer";

import { styled } from "@mui/material";

export const Drawer = styled(MuiDrawer)(() => ({
  padding: 0,
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    boxShadow: "none",
    padding: 0,
    borderRadius: 0,
  },
}));

export const styles = {
  appBar: {
    display: "flex",
    backgroundColor: "#fff",
    "@media (min-width: 1301px)": {
      display: "none",
    },
  },
};
